<template>
  <div class="stationDetailPage">
    <!-- 监测点基本信息 - 两个tab共享 -->
    <div class="detail-top">
      <div class="station-top-row">
        <div class="station-id">
          <div class="station-title">{{ equipmentData.siteName }}</div>
          <div class="station-dept" v-if="equipmentData.deptName">{{ equipmentData.deptName }}</div>
        </div>
        <div class="station-meta">
          <div class="meta-item">
            <span class="meta-label">负责人</span>
            <span class="meta-value">{{ equipmentData.manager || '无' }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">联系方式</span>
            <span class="meta-value">{{ equipmentData.telephone || '无' }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">信号强度</span>
            <span class="meta-value">{{ equipmentData.signalStrength || 0 }}</span>
          </div>
        </div>
      </div>
      <!-- tab 切换栏 + 操作按钮 -->
      <div class="detail-tabs-bar">
        <div class="tabs-group">
          <div class="tab-btn" :class="{ active: activeTab === 'alarm' }" @click="switchTab('alarm')">诊断详情</div>
          <div class="tab-btn" :class="{ active: activeTab === 'data' }" @click="switchTab('data')" v-show="isShowData">数据详情</div>
          <div class="tab-btn" :class="{ active: activeTab === 'energy' }" @click="switchTab('energy')">能耗统计</div>
        </div>
        <div class="action-group">
          <template v-if="activeTab === 'alarm'">
            <el-button size="small" type="primary" @click="openFixPopup()" v-show="hasReportPermission">人工评判</el-button>
            <el-button size="small" type="primary" @click="openEbikeConfigPopup()" v-show="equipmentData.branchId && hasEbikeConfigPermission">识别配置</el-button>
          </template>
          <template v-if="activeTab === 'data'">
            <el-button size="small" plain @click="openDataExport()">导出数据</el-button>
            <el-button size="small" plain @click="toDataManage()">监测管理</el-button>
          </template>
        </div>
      </div>
    </div>
      <app-drawer title="人工评判" :visible.sync="showPopup2" size="450px">
        <div class="fix-change">
          <div class="fix-list">
            <div class="fix-header">
              <div class="fix-part">
                <div class="fix-part1">监测点</div>
                <div class="fix-part2">{{ equipmentData.siteName }}</div>
              </div>
              <el-button size="small" type="primary" @click="openAddDrawer">新增</el-button>
            </div>
            <div class="fix-content">
              <div v-for="(item,index) in fixChangeList" :key="index">
                <fix-item :items="item" :has-publish-permission="hasPublishPermission" @handle-detail="editFixDetail" @handle-up="upFix" @handle-cancel-publish="cancelPublish" @handle-delete="deleteFixDetail"></fix-item>
              </div>
            </div>
          </div>
        </div>
      </app-drawer>

      <app-drawer title="新增人工评判" :visible.sync="showAddDrawer" :before-close="handleClose" size="480px" wrapper-class="fix-add-drawer">
        <div class="fix-change">
          <div class="fix-list">
            <div class="fix-part">
              <div class="fix-part1">监测点</div>
              <div class="fix-part2">{{ equipmentData.siteName }}</div>
            </div>
            <div class="fix-part">
              <div class="fix-part1">主要隐患</div>
              <div class="fix-part2">
                <el-select v-model="mainRisk" style="width: 80%" clearable placeholder="请选择主要隐患">
                  <el-option
                    v-for="item in alertList"
                    :key = "item.value"
                    :label = "item.label"
                    :value = "item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="fix-part" style="display: none;">
              <div class="fix-part1">隐患列表</div>
              <div class="fix-part2">
                <el-select v-model="riskIds" style="width: 80%"  multiple placeholder="请选择剩余隐患">
                  <el-option
                    v-for="item in alertList"
                    :key = "item.value"
                    :label = "item.label"
                    :value = "item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="fix-part">
              <div class="fix-part1">目标时间</div>
              <div class="fix-part2">
                <el-date-picker
                  v-model="changeRiskTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width: 80%"
                  default-time="12:00:00"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </div>
            </div>
            <div class="fix-part">
              <div class="fix-part1">问题描述</div>
              <el-input
                class="fix-part2"
                type="textarea"
                :rows="5"
                placeholder="请输入修改内容"
                v-model="riskContent">
              </el-input>
            </div>
            <div class="fix-bottom">
              <el-button size="small" type="primary" @click="confirmChangeRisk">保存</el-button>
            </div>
          </div>
        </div>
      </app-drawer>
    <div v-if="activeTab === 'alarm'" class="detail-content">
      <station-card :title="'隐患诊断'">
        <template v-slot:header>
          <div class="select-check">
            <el-button size="small" class="plain-time-btn" @click="lastHour">24小时</el-button>
            <el-button size="small" class="plain-time-btn" @click="todayDate">今日</el-button>
            <el-button size="small" class="plain-time-btn" @click="changeDate(-1)">前一天</el-button>
            <el-button size="small" class="plain-time-btn" @click="changeDate(1)">后一天</el-button>
            <el-date-picker v-model="newtm" value-format="yyyy-MM-dd" style="width: 200px;" type="date" placeholder="开始时间" :picker-options="pickerOptions" @change="getRiskTimePeriodAnalyze"></el-date-picker>
          </div>
        </template>
        <template  v-slot:default>
          <div class="linePart">
            <div class="timePart">
              <el-calendar v-model="newtm" class="calendar">
                <template #dateCell="{ date,data }">
                  <div class="date-part"
                       :class="data.isSelected ? 'is-selected' : ''"
                       @mouseenter="handleMouseEnter(data.day)"
                       @mouseleave="handleMouseLeave">
                    <div class="date-info">
                      {{ data.day.split('-')[2] }}
                    </div>
                    <div class="right-info">
                      <div class="risk-part" :class="getRiskLevelClass(data.day)">
                        <div v-if="hasSpecialTag(data.day)" class="isMis"></div>
                      </div>
                    </div>
                    <div v-show="activeDate === data.day && hasSpecialTag(data.day)" class="tooltip">
                      存在{{ riskLevel.name(6) }}
                    </div>
                  </div>
                </template>
              </el-calendar>
            </div>
            <div class="riskPart">
              <div class="time-line">
                <TimeLine :timeline-data="timeLineData" :outside-monitor-period="outsideMonitorPeriod" />
              </div>
            </div>
          </div>
        </template>
      </station-card>

      <station-card :title="'电气火灾风险指标'">
        <template v-slot:header>
          <div style="padding-right: 10px">显示时间：{{ newtm }}</div>
        </template>
        <template v-slot:default>
          <div class="point-line-part" v-show="hasFire">
            <se-chart
              chart-id="pointDetailChart"
              :title="['时间', '电气火灾风险']"
              :data="pointDetailChartData"
              :fire-columns="['电气火灾风险']"
              :level-data="pointDetailLevelData"
              :show-legend="false"
              description="点位趋势与火灾安全级别"
            />
          </div>
          <div class="point-line-part" v-show="!hasFire">
            暂无风险隐患数据
          </div>
        </template>
      </station-card>

      <div class="hidden-part" v-show="isdevice && ismisreport">
        <div class="device">
          <station-card :title="'隐患设备'" :is-show="isdevice" :no-data-title="'暂无隐患设备'">
            <template v-slot:default>
              <div class="device-container">
                <div class="device-header" v-show="showDeviceDetail">
                  <el-button size="small" @click="returnToList">
                    <i class="el-icon-arrow-left"></i> 返回
                  </el-button>
                </div>

                <div class="data-table" v-show="isdevice && !showDeviceDetail">
                  <div class="time-select">
                    <DeviceType :data="deviceTypeList"/>
                  </div>
                  <div class="list-table">
                    <el-table :data="deviceList" width="100%" height="100%">
                      <el-table-column prop="type" label="类型" align="center" min-width="60"></el-table-column>
                      <el-table-column prop="phase" label="位置" align="center" min-width="60"></el-table-column>
                      <el-table-column prop="power" label="设备功率 (W)" align="center" min-width="100"></el-table-column>
                      <el-table-column prop="residualCurrent" label="剩余电流(mA)" align="center" min-width="100"></el-table-column>
                      <el-table-column prop="lastStartupTime" label="启动时间" align="center" min-width="100"></el-table-column>
                      <el-table-column label="更多" align="center" min-width="90">
                        <template v-slot:default="scope">
                          <el-button type="text" size="small" @click="getDeviceDetail(scope.row)">详情</el-button>
                        </template>
                      </el-table-column>
                      <!-- 新增备注列 -->
                      <el-table-column prop="comment" label="备注" align="center" min-width="200">
                        <template v-slot:default="scope">
                          <div>
                            <el-input v-model="scope.row.comment" size="large" placeholder="请输入备注" @change="handleRemarkChange(scope.row)">
                              <template v-slot:append>
                                <el-button icon="el-icon-check" @click="saveRemarkDevice(scope.row)"></el-button>
                              </template>
                            </el-input>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>

                <!-- 设备详情表格 -->
                <div class="data-table" v-show="isdevice && showDeviceDetail">
                  <el-table v-show="deviceDetailList" :data="deviceDetailList" width="100%" height="100%">
                    <el-table-column prop="startUpTime" label="启动时间" align="center"></el-table-column>
                  </el-table>
                  <div class="nodata-table" v-show="!deviceDetailList">
                    暂无隐患设备详情
                  </div>
                </div>
                <div class="nodata-table" v-show="!isdevice">
                  暂无隐患设备
                </div>
              </div>
            </template>
          </station-card>
        </div>
        <div class="false-report">
          <station-card :title="riskLevel.name(6) + '定位'" :is-show="ismisreport" :no-data-title="'暂无' + riskLevel.name(6)">
            <div class="device-container">
              <div class="device-header" v-show="showMisreportDetail">
                <el-button size="small" @click="returnMisreportToList">
                  <i class="el-icon-arrow-left"></i> 返回
                </el-button>
              </div>

              <div class="data-table" v-show="ismisreport && !showMisreportDetail">
                <div class="time-select">
                  <div class="misreport">定位{{ riskLevel.name(6) }}：<span style="color: #00A870; padding: 0 2px">{{misreportType }}</span>类</div>
                  <div class="misreport">辅助定位设备：<span style="color: #00A870; padding: 0 2px">{{helpDevice}}</span>个</div>
                </div>
                <div class="list-table">
                  <el-table :data="misreportList" width="100%" height="100%">
                    <el-table-column prop="misreportType" :label="riskLevel.name(6)" align="center" min-width="80"></el-table-column>
                    <el-table-column prop="phase" label="所在相位" align="center" min-width="70"></el-table-column>
                    <el-table-column prop="residualCurrent" label="剩余电流(mA)" align="center" min-width="80"></el-table-column>
                    <el-table-column prop="power" label="设备功率 (W)" align="center" min-width="80"></el-table-column>
                    <el-table-column prop="type" label="设备类型" align="center" min-width="70"></el-table-column>
                    <el-table-column prop="lastStartupTime" label="启动时间" align="center" min-width="90"></el-table-column>
                    <el-table-column label="更多" align="center" min-width="70">
                      <template v-slot:default="scope">
                        <el-button type="text" size="small" @click="getMisReportDetail(scope.row)">详情</el-button>
                      </template>
                    </el-table-column>
                    <!-- 新增备注列 -->
                    <el-table-column prop="comment" label="备注" align="center" min-width="180">
                      <template v-slot:default="scope">
                        <div>
                          <el-input v-model="scope.row.comment" size="large" placeholder="请输入备注" @change="handleRemarkChange(scope.row)">
                            <template v-slot:append>
                              <el-button icon="el-icon-check" @click="saveRemarkMisreport(scope.row)"></el-button>
                            </template>
                          </el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <!-- 设备详情表格 -->
              <div class="data-table" v-show="ismisreport && showMisreportDetail">
                <el-table :data="misreportDetailList" width="100%" height="100%">
                  <el-table-column prop="startUpTime" label="启动时间" align="center"></el-table-column>
                </el-table>
              </div>
              <div class="nodata-table" v-show="!ismisreport">
                暂无{{ riskLevel.name(6) }}设备
              </div>
            </div>
          </station-card>
        </div>
      </div>

      <station-card :title="'现场排查'">
        <template v-slot:header>
          <el-button size="small" type="primary" @click="openAddPopup">新增</el-button>
        </template>
        <template v-slot:default>
          <div class="checkList">
            <CheckPart :items="CheckList" @edit-item="editCheckDetail" @delete-item="deleteDetailConfirm"/>
          </div>
        </template>
      </station-card>

      <!-- 新增/编辑排查记录 Drawer -->
      <app-drawer :title="isEditMode ? '编辑排查记录' : '新增排查记录'" :visible.sync="showPopup" size="480px">
        <div style="padding: 20px;">
          <div class="drawer-section">
            <el-form label-width="80px" size="small">
              <el-form-item label="排查人">
                <el-input v-model="inspector" placeholder="请输入排查人"></el-input>
              </el-form-item>
              <el-form-item label="排查日期">
                <el-date-picker v-model="inspectionTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="问题描述">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="issueDescription"></el-input>
              </el-form-item>
              <el-form-item label="图片上传">
                <div style="position: relative; display: flex; flex-wrap: wrap; gap: 10px;">
                  <div v-if="isUploading" class="custom-loading-mask" style="position: absolute; inset: 0; background: rgba(255,255,255,0.7); z-index: 1; display: flex; align-items: center; justify-content: center;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <i class="el-icon-loading" style="font-size: 20px; color: #409EFF;"></i>
                      <span>上传中...</span>
                    </div>
                  </div>
                  <div v-for="(url, index) in issueUrls" :key="index" style="position: relative">
                    <img :src="url" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;" @click.stop="openImage(url)" alt=""/>
                    <span @click.stop="removeImage(index)"
                      style="position: absolute; top: -5px; right: -5px; cursor: pointer; background: #f56c6c; color: white; border-radius: 50%; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; font-size: 10px;">
                      ×
                    </span>
                  </div>
                  <el-upload
                    v-if="issueUrls.length < 5"
                    class="avatar-uploader"
                    :http-request="customUpload"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    action="">
                    <div style="width: 60px; height: 60px; border: 2px dashed #dcdfe6; border-radius: 4px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #909399;">
                      <i class="el-icon-plus" style="font-size: 20px;"></i>
                    </div>
                  </el-upload>
                </div>
                <div style="font-size: 12px; color: #909399; margin-top: 4px;">最多上传5张图片</div>
              </el-form-item>
            </el-form>
          </div>
          <div style="display: flex; justify-content: flex-end; gap: 8px; padding-top: 16px; border-top: 1px solid #ebeef5;">
            <el-button size="small" @click="showPopup = false; resetPopup()">取 消</el-button>
            <el-button size="small" type="primary" @click="confirmInsert">保 存</el-button>
          </div>
        </div>
      </app-drawer>

      <div class="history-risk">
        <div class="history">
<!--          <station-card :title="'历史隐患'" :is-show="isHisList" :no-data-title="'暂无历史隐患'">-->
<!--            <div class="data-table">-->
<!--              <div class="time-select">-->
<!--                <div>-->
<!--                  <span>起止时间：</span>-->
<!--                  <el-date-picker v-model="hissttm" value-format="yyyy-MM-dd" style="width: 130px;" type="date" placeholder="开始时间"></el-date-picker>-->
<!--                  - -->
<!--                  <el-date-picker style="width: 130px" v-model="hisedtm" value-format="yyyy-MM-dd" type="date" placeholder="结束时间"></el-date-picker>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <span style="margin-left: 20px;">整改状态：</span>-->
<!--                  <el-select v-model="statius" style="width: 100px;margin-right: 12px;" placeholder="请选择">-->
<!--                    <el-option v-for="(item,index) in dosta" :key="index" :label="item.label" :value="item.value"></el-option>-->
<!--                  </el-select>-->
<!--                </div>-->
<!--                <div style="display: flex; justify-content: center; gap: 2px">-->
<!--                  <div class="btn search" @click="getRiskList()">查询</div>-->
<!--                  <div class="btn restart" @click="reset()">重置</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="list-table">-->
<!--                <el-table :data="hisList" width="100%" height="100%">-->
<!--                  <el-table-column prop="riskLevelName" align="center" label="隐患等级"></el-table-column>-->
<!--                  <el-table-column prop="riskName" align="center" label="隐患类型"></el-table-column>-->
<!--                  <el-table-column prop="status" align="center" label="整改状态"></el-table-column>-->
<!--                  <el-table-column prop="updateTime" width="200" align="center" label="上报时间"></el-table-column>-->
<!--                  <el-table-column align="center" label="操作">-->
<!--                    <template v-slot:default="scope">-->
<!--                      <div class="detail-button" v-if="scope.row.status === '已处理'" @click="openhisLayer(scope.row); isdeal=false">查看</div>-->
<!--                      <div class="detail-button" v-else @click="openhisLayer(scope.row); isdeal=true">处置</div>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                </el-table>-->
<!--              </div>-->
<!--              <div class="hidden-page">-->
<!--                <el-pagination @current-change="pageChange" background :current-page="nowpage" :page-size="riskpage" layout="total,prev, pager, next, jumper" :total="riskSum">-->
<!--                </el-pagination>-->
<!--              </div>-->
<!--            </div>-->
<!--          </station-card>-->
          <station-card :title="'隐患统览'" :is-show="isRiskTypeList" :no-data-title="'暂无隐患统览数据'" >
            <div class="data-table" v-show="ishis">
              <el-table :data="riskTypeList" width="100%" height="100%">
                <el-table-column prop="riskLevelName" align="center" label="隐患等级"></el-table-column>
                <el-table-column prop="alertLevelName" align="center" label="隐患类型"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template v-slot:default="scope">
                    <el-button type="text" size="small" @click="opendetail(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="data-table" v-show="!ishis">
              <div class="risk-history-title">
                <span>
                  <img src="../../assets/home/returnbtn.webp" class="img-button" alt="" @click="returnback()">
                </span>
                {{ alertLevelName }}
              </div>
              <span class="time-select">
                    <span>起止时间：</span>
                    <el-date-picker v-model="hissttm2" value-format="yyyy-MM-dd" style="width: 130px;" type="date" placeholder="开始时间"></el-date-picker>
                    -
                    <el-date-picker style="width: 130px" v-model="hisedtm2" value-format="yyyy-MM-dd" type="date" placeholder="结束时间"></el-date-picker>

                    <el-button size="small" type="primary" @click="getRisktypeall()">查询</el-button>
                    <el-button size="small" @click="reset2()">重置</el-button>
                </span>
              <div class="list-table">
                <el-table :data="detailList" align="center">
                  <el-table-column prop="createTime" align="center" label="上报时间"></el-table-column>
                </el-table>
              </div>
              <div class="hidden-page">
                <el-pagination @current-change="pageChange1" background :current-page="nowpage1" :page-size="riskpage1" layout="total,prev, pager, next, jumper" :total="riskSum1">
                </el-pagination>
              </div>
            </div>
          </station-card>
        </div>
        <div class="total">
          <station-card :title="'监测点处置'">
            <template v-slot:header>
              <el-button size="small" type="primary" @click="openDisposePopup()">新增处置</el-button>
            </template>
            <template v-slot:default>
              <div class="data-table" v-if="disposeRecordList.length > 0">
                <el-table :data="disposeRecordList" style="width: 100%; height: 100%">
                  <el-table-column prop="disposerName" label="处置人" align="center" min-width="80"></el-table-column>
                  <el-table-column prop="disposeTime" label="处置时间" align="center" min-width="150"></el-table-column>
                  <el-table-column label="隐患等级" align="center" min-width="150">
                    <template v-slot:default="scope">
                      <el-tag v-for="level in scope.row.riskLevels" :key="level" size="mini" style="margin: 2px; border: none;"
                              :color="riskLevel.backgroundColor(level)" :style="{ color: riskLevel.color(level), backgroundColor: riskLevel.backgroundColor(level), borderColor: riskLevel.backgroundColor(level) }">
                        {{ riskLevelOptions.find(o => o.value === level) ? riskLevelOptions.find(o => o.value === level).label : level }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="disposeContent" label="处置内容" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column label="处置照片" align="center" min-width="120">
                    <template v-slot:default="scope">
                      <div v-if="scope.row.disposePhotoUrl && scope.row.disposePhotoUrl.length > 0" style="display: flex; flex-wrap: wrap; gap: 4px; justify-content: center;">
                        <img v-for="(url, i) in scope.row.disposePhotoUrl" :key="i" :src="url"
                             style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                             @click="previewDisposePhoto(url)" alt="">
                      </div>
                      <span v-else style="color: #909399;">无</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="60">
                    <template v-slot:default="scope">
                      <el-button type="text" size="small" @click="deleteDispose(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="hidden-page">
                  <el-pagination @current-change="disposePageChange" background :current-page="disposePageNum" :page-size="10" layout="total, prev, pager, next" :total="disposeRecordTotal"></el-pagination>
                </div>
              </div>
              <div v-else class="nodata-table">暂无处置记录</div>
            </template>
          </station-card>
        </div>
      </div>

      <!-- 新增处置记录 Drawer -->
      <app-drawer title="新增处置记录" :visible.sync="showDisposePopup" size="450px">
        <div style="padding: 20px;">
          <el-form ref="disposeFormRef" :model="disposeForm" label-width="100px" size="medium">
            <el-form-item label="处置人" required>
              <el-input v-model="disposeForm.disposerName" placeholder="请输入处置人名称" maxlength="50" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="处置时间" required>
              <el-date-picker v-model="disposeForm.disposeTime" type="datetime" placeholder="请选择处置时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker>
            </el-form-item>

            <el-form-item label="隐患等级" required>
              <el-select v-model="disposeForm.riskLevels" multiple placeholder="请选择隐患等级" style="width: 100%">
                <el-option v-for="item in riskLevelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="处置照片">
              <div style="position: relative; display: flex; flex-wrap: wrap; gap: 10px;">
                <div v-if="isDisposeUploading" class="custom-loading-mask" style="position: absolute; inset: 0; background: rgba(255,255,255,0.7); z-index: 1; display: flex; align-items: center; justify-content: center;">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <i class="el-icon-loading" style="font-size: 20px; color: #409EFF;"></i>
                    <span>上传中...</span>
                  </div>
                </div>
                <div v-for="(url, index) in disposePhotos" :key="index" style="position: relative">
                  <img :src="url" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;" @click.stop="previewDisposePhoto(url)" alt="">
                  <span @click.stop="removeDisposePhoto(index)"
                    style="position: absolute; top: -5px; right: -5px; cursor: pointer; background: #f56c6c; color: white; border-radius: 50%; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; font-size: 10px;">
                    ×
                  </span>
                </div>
                <el-upload
                  v-if="disposePhotos.length < 9"
                  class="avatar-uploader"
                  :http-request="customDisposeUpload"
                  :show-file-list="false"
                  :before-upload="beforeDisposeUpload"
                  action="">
                  <div style="width: 60px; height: 60px; border: 2px dashed #dcdfe6; border-radius: 4px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #909399;">
                    <i class="el-icon-plus" style="font-size: 20px;"></i>
                  </div>
                </el-upload>
              </div>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">最多上传9张照片</div>
            </el-form-item>

            <el-form-item label="处置内容" required>
              <el-input v-model="disposeForm.disposeContent" type="textarea" :rows="4" placeholder="请输入处置内容" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-form>

          <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; padding-top: 16px; border-top: 1px solid #ebeef5;">
            <el-button @click="showDisposePopup = false">取 消</el-button>
            <el-button type="primary" :loading="isDisposeSubmitting" @click="submitDispose()">提 交</el-button>
          </div>
        </div>
      </app-drawer>

      <!-- 电动自行车违规充电识别配置 Drawer -->
      <app-drawer title="电动自行车违规充电识别配置" :visible.sync="showEbikeConfigPopup" size="620px">
        <div v-loading="isEbikeConfigLoading" style="padding: 20px;">
          <el-form :model="ebikeConfigForm" label-width="140px" size="small">
            <el-form-item label="启用识别">
              <el-switch v-model="ebikeConfigForm.enabled" active-text="开" inactive-text="关"></el-switch>
            </el-form-item>

            <el-form-item label="演示模式">
              <el-switch v-model="ebikeConfigForm.demoMode" active-text="开" inactive-text="关" @change="toggleDemoMode"></el-switch>
              <span class="ebike-config-tip" style="color: #E6A23C;" v-if="ebikeConfigForm.demoMode">纯净点位快速检测，可能增加误报</span>
              <span class="ebike-config-tip" v-else>适用于无干扰点位，自动调整参数加速检测</span>
            </el-form-item>

            <el-divider content-position="left">算法阈值参数</el-divider>

            <el-form-item label="功率增量阈值 (W)">
              <el-input-number v-model="ebikeConfigForm.deltaPThreshold" :min="1" :max="5000" :step="10" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">ΔP超过此值触发检测（兼具增量下限职责）</span>
            </el-form-item>

            <el-form-item label="增量功率上限 (W)">
              <el-input-number v-model="ebikeConfigForm.powerMax" :min="0" :max="10000" :step="100" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">ΔP高于此值排除大功率工业设备</span>
            </el-form-item>

            <el-form-item label="反推PF下限">
              <el-input-number v-model="ebikeConfigForm.pfMin" :min="0" :max="1" :step="0.01" :precision="2" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">新接入设备估算PF下限（非总PF）</span>
            </el-form-item>

            <el-form-item label="反推PF上限">
              <el-input-number v-model="ebikeConfigForm.pfMax" :min="0" :max="1" :step="0.01" :precision="2" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">新接入设备估算PF上限（非总PF）</span>
            </el-form-item>


            <el-form-item label="PF宽容度">
              <el-input-number v-model="ebikeConfigForm.pfTolerance" :min="0" :max="0.5" :step="0.01" :precision="2" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">SUSPECT/ALERTED状态PF扩展范围</span>
            </el-form-item>

            <el-form-item label="基线窗口 (分钟)">
              <el-input-number v-model="ebikeConfigForm.baselineWindowMinutes" :min="1" :max="120" :step="5" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">计算基线均值的滑动窗口时长</span>
            </el-form-item>

            <el-divider content-position="left">滑动窗口参数（脉冲充电适配）</el-divider>

            <el-form-item label="SUSPECT窗口 (分钟)">
              <el-input-number v-model="ebikeConfigForm.suspectWindowMinutes" :min="1" :max="30" :step="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">SUSPECT滑动窗口时长，脉冲充电不中断确认</span>
            </el-form-item>

            <el-form-item label="告警解除窗口 (分钟)">
              <el-input-number v-model="ebikeConfigForm.clearWindowMinutes" :min="1" :max="60" :step="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">告警解除滑动窗口时长，脉冲间隙不重置计数</span>
            </el-form-item>

            <el-divider content-position="left">多维评分参数（v2增强）</el-divider>

            <el-form-item label="评分阈值">
              <el-input-number v-model="ebikeConfigForm.scoreThreshold" :min="0" :max="4.5" :step="0.1" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">SUSPECT阶段评分≥此值判定充电器，无Inx时F3+F6+F5=2.5刚好可达</span>
            </el-form-item>

            <el-form-item label="PFC评分阈值">
              <el-input-number v-model="ebikeConfigForm.pfcScoreThreshold" :min="0" :max="4.5" :step="0.1" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">主动PFC充电器(PF>0.85)需更高评分才确认，告警等级降档</span>
            </el-form-item>

            <el-form-item label="ΔInx下限 (mA)">
              <el-input-number v-model="ebikeConfigForm.inxMinThreshold" :min="0" :max="500" :step="5" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">谐波增量低于此值不计入F1得分</span>
            </el-form-item>

            <el-form-item label="ΔInx上限 (mA)">
              <el-input-number v-model="ebikeConfigForm.inxMaxThreshold" :min="0" :max="1000" :step="10" :precision="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">谐波增量高于此值排除大谐波干扰源</span>
            </el-form-item>

            <el-divider content-position="left">采样点数参数（低频率设备适配）</el-divider>

            <el-form-item label="评分最少点数">
              <el-input-number v-model="ebikeConfigForm.minScorePoints" :min="1" :max="10" :step="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">SUSPECT阶段至少N个数据点才计算评分，三相设备(10min)建议2，单相(30s)保持3</span>
            </el-form-item>

            <el-form-item label="基线最少点数">
              <el-input-number v-model="ebikeConfigForm.minBaselinePointsForConfidence" :min="1" :max="20" :step="1" style="width: 200px"></el-input-number>
              <span class="ebike-config-tip">基线数据点不足此值时增量阈值翻倍，三相设备(10min)建议3，单相(30s)保持5</span>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex; justify-content: space-between; padding: 20px; border-top: 1px solid #ebeef5;">
          <el-button size="small" @click="resetEbikeConfig()">恢复默认</el-button>
          <div>
            <el-button size="small" @click="showEbikeConfigPopup = false">取 消</el-button>
            <el-button type="primary" size="small" :loading="isEbikeConfigSubmitting" @click="submitEbikeConfig()">保 存</el-button>
          </div>
        </div>
      </app-drawer>

    </div>
    <div v-if="activeTab === 'energy'" style="padding: 20px 0;">
      <station-card title="能耗统计" class="energy-card">
        <template v-slot:default>
          <powerData />
        </template>
      </station-card>
    </div>
    <div v-if="activeTab === 'data'">
      <data-detail ref="dataDetailRef" />
    </div>
    <!--    <div class="save-all" v-show="issave === 'aqjc'">-->
    <!--      <div class="power-data">-->
    <!--        监测点安全数据-->
    <!--      </div>-->
    <!--      <div class="data-card">-->
    <!--        <div class="btn-item" v-loading="isload" @click="getnewdata()">-->
    <!--          获取实时数据-->
    <!--        </div>-->
    <!--        <div class="save-item">-->
    <!--          <div class="blue-blank"></div>-->
    <!--          <div class="save-content">-->
    <!--            <div>-->
    <!--              漏电流(mA)：<span :class="'font' + elelast.lev" style="margin-right: 20px;">{{ elelast.value }}</span>-->
    <!--              <span v-show="isthree!=='2'">箱温(℃)：<span :class="'font' + boxtem.lev">{{ boxtem.value=='-45.0'? "-":boxtem.value }}</span></span>-->
    <!--            </div>-->
    <!--            <div class="item-tips">-->
    <!--              提示：<span class="red-font ">红色</span>代表危险、<span class="green-font">绿色</span>代表安全-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="save-item">-->
    <!--          <div class="blue-blank">-->

    <!--          </div>-->
    <!--          <div class="save-content">-->
    <!--            <div>-->
    <!--              电气火灾风险指数：<span :class="'font' + dqhzparm.lev" style="margin-right: 20px;">{{ dqhzparm.value }}</span>-->
    <!--              <span v-if="jylhparm.value">绝缘老化风险指数:</span>-->
    <!--              <span :class="'font' + jylhparm.lev">{{ jylhparm.value }}</span>-->
    <!--            </div>-->
    <!--            <div class="item-tips">-->
    <!--              提示：<span class="red-font">红色</span>代表重大风险、<span class="org-font">橙色</span>代表较大风险、<span class="yel-font">黄色</span>代表一般风险、-->
    <!--              <span class="blue-font">蓝色</span>代表较低风险、<span class="green-font">绿色</span>代表无风险-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--      </div>-->
    <!--      <div class="data-table" v-show="isthree!=null">-->
    <!--        <div class="singletable" v-if="isthree=='2'">-->
    <!--          <div class="table-top">-->
    <!--            <span>剩余电流（mA）</span>-->
    <!--            <span>剩余基波电流（mA）</span>-->
    <!--            <span>剩余谐波电流（mA）</span>-->
    <!--            <span>电压（V）</span>-->
    <!--            <span>负荷电流（A）</span>-->
    <!--            <span>基波电流（A）</span>-->
    <!--            <span>谐波电流（A）</span>-->

    <!--            <span>功率因数</span>-->
    <!--            <span>有功功率(W)</span>-->
    <!--            <span>有功电度(kwh)</span>-->
    <!--            <span>温度(℃)</span>-->

    <!--          </div>-->
    <!--          <div class="table-bom">-->

    <!--            <span v-for="item in singlesavedata[0].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--            <span v-for="item in singlesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--            <span v-for="item in singlesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--            <span v-for="item in singlesavedata[3].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--            <span v-for="item in singlesavedata[5].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--            <span v-for="item in singlesavedata[4].paramSafeDataList" :class="'font' + item.checkSafe">-->
    <!--              <span style="width: 60px;">-->
    <!--                {{ (item.paramValue * electricMul).toFixed(4)}}-->
    <!--              </span>-->
    <!--              <span style="font-size: 10px;">-->
    <!--                ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(4)}})-->
    <!--              </span>-->
    <!--            </span>-->
    <!--            <span v-for="item in singlesavedata[6].paramSafeDataList" :class="'font' + item.checkSafe">{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="alltable" v-else-if="isthree=='1'">-->
    <!--          <div v-if="isb">-->
    <!--            <div class="table-top">-->
    <!--              <span></span>-->
    <!--              <span>电压（V）</span>-->
    <!--              <span>电流（A）</span>-->
    <!--              &lt;!&ndash;                  <span>谐波电流（A）</span>&ndash;&gt;-->
    <!--              <span>有功电度(kwh)</span>-->
    <!--              <span>有功功率（W）</span>-->
    <!--              <span>功率因数</span>-->
    <!--              <span>温度(°C)</span>-->
    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>A相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[0].paramSafeDataList" :class="'font' + item.checkSafe" v-show="index!=2">-->
    <!--                <span v-if="index!=3 ">-->
    <!--                  {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                </span>-->
    <!--                <span v-else style="width: 100%;background-color: none;">-->
    <!--                  <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                  </span>-->
    <!--                  <span style="font-size: 10px;">-->
    <!--                    ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--              </span>-->
    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>B相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe" v-show="index!=2">-->
    <!--                <span v-if="index!=3 ">-->
    <!--                  {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                </span>-->
    <!--                <span v-else style="width: 100%;background-color: none;">-->
    <!--                  <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                  </span>-->
    <!--                  <span style="font-size: 10px;">-->
    <!--                    ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--              </span>-->
    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>C相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe" v-show="index!=2">-->
    <!--                <span v-if="index!=3">-->
    <!--                  {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                </span>-->
    <!--                <span v-else style="width: 100%;background-color: none;">-->
    <!--                  <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                  </span>-->
    <!--                  <span style="font-size: 10px;">-->
    <!--                    ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--              </span>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div v-else>-->
    <!--            <div class="table-top">-->
    <!--              <span></span>-->
    <!--              <span>电压（V）</span>-->
    <!--              <span>电流（A）</span>-->
    <!--              <span>谐波电流（A）</span>-->
    <!--              <span>有功电度(kwh)</span>-->
    <!--              <span>有功功率（W）</span>-->
    <!--              <span>功率因数</span>-->
    <!--              <span>温度(°C)</span>-->
    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>A相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[0].paramSafeDataList" :class="'font' + item.checkSafe">-->
    <!--                                        <span v-if="index!=3">-->
    <!--                                            {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                                        </span>-->
    <!--                                        <span v-else style="width: 100%;background-color: none;">-->
    <!--                                            <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                                                {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                                            </span>-->
    <!--                                            <span style="font-size: 10px;">-->
    <!--                                                ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                                            </span>-->
    <!--                                        </span>-->
    <!--                                    </span>-->

    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>B相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe">-->
    <!--                                        <span v-if="index!=3">-->
    <!--                                            {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                                        </span>-->
    <!--                                        <span v-else style="width: 100%;background-color: none;">-->
    <!--                                            <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                                                {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                                            </span>-->
    <!--                                            <span style="font-size: 10px;">-->
    <!--                                                ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                                            </span>-->
    <!--                                        </span>-->
    <!--                                    </span>-->
    <!--            </div>-->
    <!--            <div class="table-bom">-->
    <!--              <span>C相</span>-->
    <!--              <span v-for="(item , index) in threesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe">-->
    <!--                                        <span v-if="index!=3">-->
    <!--                                            {{item.paramValue=='-45.0'?'-':item.paramValue}}-->
    <!--                                        </span>-->
    <!--                                        <span v-else style="width: 100%;background-color: none;">-->
    <!--                                            <span style="width: 60px;display: inline-block;background-color: none;">-->
    <!--                                                {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}-->
    <!--                                            </span>-->
    <!--                                            <span style="font-size: 10px;">-->
    <!--                                                ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})-->
    <!--                                            </span>-->
    <!--                                        </span>-->
    <!--                                    </span>-->
    <!--            </div>-->
    <!--          </div>-->

    <!--        </div>-->
    <!--        <div class="singletable" v-else-if="isthree=='3'">-->
    <!--          <div class="table-top" style="width: 186px;">-->


    <!--            <span style="width: 100%;">负荷电流（A）</span>-->

    <!--          </div>-->
    <!--          <div class="table-bom">-->

    <!--            <span>{{elesavedata.paramValue}}</span>-->

    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="nodata-table" v-show="isthree==null">-->
    <!--        暂无数据-->
    <!--      </div>-->
    <!--      <div class="per-con">-->
    <!--        电表倍率：{{nowbl}}-->
    <!--        <img @click="showbl()" style="width: 18px;margin-left: 10px;cursor:pointer;" src="../../assets/home/changedata.webp" alt="">-->
    <!--      </div>-->


    <!--      <div class="power-data">-->
    <!--        监测点安全统计-->
    <!--      </div>-->
    <!--      <div class="item-group" style="margin-top: 24px;">-->
    <!--        <span class="item-btn " :class="isrisk=='yhtj'?'active-btn':''" @click="changerisk('yhtj')">-->
    <!--          隐患统计-->
    <!--          <div class="blue-blank"></div>-->
    <!--        </span>-->
    <!--        <span class="item-btn " :class="isrisk=='bjtj'?'active-btn':''" @click="changerisk('bjtj')">-->
    <!--          报警统计-->
    <!--          <div class="blue-blank"></div>-->
    <!--        </span>-->
    <!--        <span class="item-btn " :class="isrisk=='fxzb'?'active-btn':''" @click="changerisk('fxzb')">-->
    <!--          风险指标-->
    <!--          <div class="blue-blank"></div>-->
    <!--        </span>-->
    <!--        <div class="gray-line"></div>-->
    <!--      </div>-->
    <!--      <div class="risk-cav" v-show="isrisk=='yhtj'">-->
    <!--        <div class="cir-blank">-->
    <!--          <div class="cir-title">-->
    <!--            <span class="blue-blank"></span>-->
    <!--            <span class="new-risk">-->
    <!--              隐患月新增：{{ thisMonthCount }}项-->
    <!--            </span>-->
    <!--            <span class="big-risk">-->
    <!--              其中重大风险：{{ significantriskcount }}项，-->
    <!--            </span>-->
    <!--            <span>-->
    <!--              较大风险：{{ greaterriskcount }}项-->
    <!--            </span>-->
    <!--          </div>-->
    <!--          <div class="cir-cav" id="riskCav">-->

    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="cir-table">-->
    <!--          <div class="gray-line">-->

    <!--          </div>-->
    <!--          <div class="detail-table">-->
    <!--            <div class="cir-title">-->
    <!--              <span class="blue-blank"></span>-->
    <!--              <span class="new-risk">-->
    <!--                未整改隐患：{{ unHandledCount }}项-->
    <!--              </span>-->
    <!--              <span class="big-risk">-->
    <!--                已整改隐患：{{ handledCount }}项-->
    <!--              </span>-->
    <!--            </div>-->
    <!--            <div class="table-blank">-->
    <!--              <el-table :data="risktable" style="width: 100%" class="tableList">-->
    <!--                <el-table-column prop="riskName" label="隐患名称" align="center">-->
    <!--                </el-table-column>-->
    <!--                <el-table-column prop="createTime" label="发生时间" align="center"> </el-table-column>-->
    <!--                <el-table-column prop="expireDay" label="逾期时间(d)" align="center">-->
    <!--                </el-table-column>-->
    <!--                <el-table-column prop="time" label="操作" align="center">-->
    <!--                  <template slot-scope="scope">-->
    <!--                    <el-button class="dobtn" type="primary" @click="openhisLayer(scope.row);isdeal=true">处置</el-button>-->
    <!--                  </template>-->
    <!--                </el-table-column>-->
    <!--              </el-table>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="warm-cav" v-show="isrisk=='bjtj'">-->
    <!--        <savechart />-->
    <!--      </div>-->
    <!--      <div class="warm-cav" v-show="isrisk=='fxzb'">-->
    <!--        <powelechart />-->
    <!--      </div>-->
    <!--    </div>-->

    <!--隐患处置 Drawer-->
    <app-drawer title="隐患处置" :visible.sync="dialogVisible" size="500px">
      <div style="padding: 20px;">
        <div v-show="isdeal" class="drawer-section">
          <div class="drawer-section-title">隐患处理</div>
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea1" style="margin-bottom: 16px;"></el-input>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px;">
            <el-checkbox v-model="checked">确定已整改</el-checkbox>
            <el-button type="primary" @click="uploadDeal()">提 交</el-button>
          </div>
        </div>
        <div class="drawer-section">
          <div class="drawer-section-title">处理历史</div>
          <div class="history-steps" v-if="dealList.length > 0">
            <el-steps direction="vertical" :active="1">
              <el-step v-for="(item, index) in dealList" :key="index">
                <div slot="title" style="display: flex; justify-content: space-between">
                  <span class="fontStyle"> {{ item.updateTime }}</span>
                  <span> {{ item.status }}</span>
                </div>
                <div slot="description">
                  <p class="fontStyle">{{ item.measure }}</p>
                  <div class="fontStyle" style="width: 100%; text-align: right">{{ item.handlerName }}</div>
                </div>
              </el-step>
            </el-steps>
          </div>
          <div v-else style="text-align: center; color: #909399; padding: 20px;">暂无处理记录</div>
        </div>
      </div>
    </app-drawer>

    <!--电表倍率 Drawer-->
    <app-drawer title="电表倍率" :visible.sync="showbltc" size="400px">
      <div style="padding: 20px;">
        <div class="drawer-section">
          <div class="drawer-section-title">修改倍率</div>
          <el-input placeholder="请输入倍率" v-model="nowbl2" style="margin-bottom: 20px;"></el-input>
          <div style="display: flex; justify-content: flex-end;">
            <el-button type="primary" @click="uploadbl()">提 交</el-button>
          </div>
        </div>
      </div>
    </app-drawer>
  </div>
</template>

<script>
import Vue from "vue";
import powerData from "../stationManagePage/components/powerdata";
import * as echarts from 'echarts';
import TimeLine from "pages/stationManagePage/components/TimeLine.vue";
import StationCard from "pages/stationManagePage/components/stationCard.vue";
import CheckPart from "pages/stationManagePage/components/checkpart.vue";
import DeviceType from "pages/stationManagePage/components/devicetype.vue";
import { getEquipStartup, getDeviceDetail, returnToList, getDeviceType } from "./utils/deviceUtils";
import { getMisReport, getMisReportDetail, saveRemarkMisreport, returnMisreportToList, getMisReportType } from "./utils/misreportUtils"
import { getRiskList, getRiskDeal, getRiskTypeList, getRiskTypeAll, changeTitle, getTitleList, getRiskOne, getRiskTwo, getRiskThree } from './utils/riskUtils';
import { handleCalendarChange, getCalendarDate, getRiskLevelClass, hasSpecialTag, getRiskTimePeriodAnalyze, initTimelineChart, getRiskColor, getFireData} from './utils/timelineUtils';
import { openAddPopup, openFixPopup, editFixDetail, deleteFixDetail, upFix as upFixApi, cancelPublish as cancelPublishApi, editCheckDetail, beforeUpload, customUpload, removeImage, confirmInsert, confirmChangeRisk, resetPopup, resetPopup2, deleteDetail, openImage, getCheckList, getChangeList } from './utils/inspectionUtils';
import { drewcav, drewcav2, gettrendCav, getriskCav } from './utils/chartUtils';
import { getEquipmentList, getcavdata, changesave, changerisk, getnow, getnewdata, getnowtime, changeitem } from './utils/equipmentUtils';
import dataDetail from './dataDetail.vue';
import { getSaveData, getdbbl, uploadbl, showbl } from './utils/saveDataUtils';
import { uploadDeal, isToday, reset, reset2, returnback, opendetail, openhisLayer, handlepageClick, changeDate, todayDate, lastHour, handleRemarkChange, saveRemarkDevice } from './utils/uiUtils';
import { openDisposePopup, resetDisposePopup, beforeDisposeUpload, customDisposeUpload, removeDisposePhoto, submitDispose, getDisposeList, disposePageChange, previewDisposePhoto, deleteDispose } from './utils/disposeUtils';
import { openEbikeConfigPopup, submitEbikeConfig, resetEbikeConfig, toggleDemoMode } from './utils/ebikeConfigUtils';
import riskLevel from '@/scripts/riskLevel'
import SeChart from "components/se-chart.vue";
import AlertLevel from "@/scripts/AlertLevel";
import FixItem from "pages/stationManagePage/components/fixItem.vue";
// 将echarts挂载到Vue原型上，使所有组件都能访问到echarts
Vue.prototype.$echarts = echarts

export default {
  name: "stationDetailV2",
  computed: {
    riskLevel() {
      return riskLevel
    },

    pointDetailChartData() {
      const fd = this.FireData.freezeDatas || [];
      return fd.slice(1);
    },

    pointDetailLevelData() {
      const cd = this.FireData.checkSafeDatas || [];
      return cd.slice(1).map(row => {
        const level = row && row[1] != null ? String(row[1]) : '1';
        return [null, level];
      });
    },

    hasFire() {
      const fd = this.FireData && this.FireData.freezeDatas;
      return Array.isArray(fd) && fd.length > 1;
    },


  },
  created() {
    this.alertList = AlertLevel.getOptions();
  },
  data() {
    return {
      menusList:[],
      isShowData: false,
      hasPublishPermission: false,
      hasReportPermission: false,
      hasEbikeConfigPermission: false,
      activeTab: 'alarm',
      showList: false,
      FireData:[],
      timeLineData: [],
      outsideMonitorPeriod: false,
      deviceList: [], // 设备列表数据
      deviceTypeList:[],
      misreportList: [], // 设备列表数据
      misreportType:'3', //定位误报源
      helpDevice:'', //辅助定位设备
      showDeviceDetail: false, // 控制是否显示详情视图
      showMisreportDetail: false, // 控制是否显示详情视图
      deviceDetailList: [], // 存储设备详情数据
      misreportDetailList: [], // 存储误报源详情数据
      activeDate: "", // 用于跟踪当前鼠标悬停的日期
      isMis:false,
      detailList: [],
      checked:false,
      alertLevelName:"",
      textarea1:"",
      dialogVisible:false,
      isdevice:true,
      ismisreport:true,
      dealList:[],
      riskTypeList:[],
      isRiskTypeList: true,
      CheckList:[],
      issave:"aqjc",
      isrisk:"yhtj",
      hissttm:"",
      hissttm2:"",
      warmedtm:"",
      warmsttm:"",
      edtm:"",
      wastnewtm: "",
      newtm:"",
      prevDate:"",
      nextDate:"",
      saveid:"",
      hisedtm:"",
      hisedtm2:"",

      currentMonth:'',
      statius:"",
      tableData:[],
      dosta:[
        {
          label:"未处理",
          value:'1'
        },     {
          label:"全部",
          value:null
        },   {
          label:"已处理",
          value:"2"
        },  {
          label:"处理中",
          value:"3"
        },
      ],
      hisList:[],
      isHisList: true,
      ishis:true,
      isdeal:"",
      nowpage:1,
      nowpage1:1,
      nowbl:1,
      riskAll:[],
      riskpage:10,
      riskpage1:10,
      riskSum:0,
      riskSum1:0,
      checkPage:1,
      checkPageSize:9,
      checkTotal:0,
      itemType:"",
      alertMessage:"",
      calendarData:{},
      equipmentData:{
        siteName:"",
        manager:"",
        telephone:"",
        signalStrength:"",
      },
      alertLevel:null,
      showbltc:false,
      greaterriskcount:"",
      thisMonthCount:"",
      handledCount:"",
      unHandledCount:"",
      significantriskcount:null,
      riskId:"",
      electricMul:1,
      quickScreen:"",
      nowbl2:1,
      elelast: {
        value:"",
        lev:"",
      },
      boxtem:{
        value:"",
        lev:"",
      },
      dqhzparm:{
        value:"",
        lev:"",
      },
      jylhparm:{
        value:"",
        lev:"",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      showPopup: false,

      showPopup2: false,
      showAddDrawer: false,
      fixAdd: false,
      fixChangeList:[],
      isRiskChange: false,
      changeId: '',
      alertList: [],
      mainRisk: '',
      mainRiskName: '',
      riskIds: [],
      riskIdNames: [],
      riskContent: '',
      changeRiskTime:'',
      publishStatus: "0",
      isDelete:false,
      fixDelete:false,

      isUploading: false,
      inspector: '',
      inspectionTime: '',
      issueDescription:'',
      issueUrl:"",
      issuePath:"",
      issueThumbnailUrl:"",
      issueThumbnailPath:"",
      issueUrls:[],
      issuePaths:[],
      issueThumbnailUrls:[],
      issueThumbnailPaths:[],
      editCheckId:null,
      isEditMode: false,

      // 处置相关
      showDisposePopup: false,
      isDisposeUploading: false,
      isDisposeSubmitting: false,
      disposeForm: {
        disposerName: '',
        disposeTime: '',
        riskLevels: [],
        disposeContent: ''
      },
      disposePhotos: [],
      disposePhotoPaths: [],
      disposePhotoThumbnailPaths: [],
      disposeRecordList: [],
      disposeRecordTotal: 0,
      disposePageNum: 1,
      riskLevelOptions: [
        { value: 2, label: '早期风险' },
        { value: 3, label: '一般风险' },
        { value: 4, label: '较大风险' },
        { value: 5, label: '严重风险' },
        { value: 6, label: '干扰缺陷' }
      ],

      // 电动自行车充电识别配置
      showEbikeConfigPopup: false,
      isEbikeConfigLoading: false,
      isEbikeConfigSubmitting: false,
      ebikeConfigForm: {
        enabled: true,
        deltaPThreshold: 80.0,
        powerMax: 1200.0,
        pfMin: 0.45,
        pfMax: 0.75,
        pfTolerance: 0.10,
        baselineWindowMinutes: 30,
        demoMode: false,
        suspectWindowMinutes: 5,
        clearWindowMinutes: 10,
        scoreThreshold: 2.5,
        pfcScoreThreshold: 3.0,
        inxMinThreshold: 30.0,
        inxMaxThreshold: 250.0
      },
    };
  },
  methods: {
    // ponytail: 清理历史遗留的非法 saveid（字符串 "undefined"、菜单标题、报告编号等），避免传给后端整数参数
    sanitizeSaveId(id) {
      const s = id === undefined || id === null ? '' : String(id).trim()
      if (s === '' || isNaN(Number(s))) {
        sessionStorage.removeItem('saveid')
        return ''
      }
      return s
    },
    handleClose(done){
      this.$confirm('是否保存当前内容？', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '不保存',
        type: 'warning'
      }).then(() => {
        // 用户选择保存，执行保存逻辑
        this.confirmChangeRisk().then(() => {
          if (done) {
            done();
          }
          this.showAddDrawer = false;
        }).catch(() => {
          // 保存失败，不关闭
        });
      }).catch(() => {
        // 用户选择不保存，直接关闭
        if (done) {
          done();
        }
        this.showAddDrawer = false;
      });
    },

    editFixDetail(items){
      editFixDetail(this, items)
    },

    deleteFixDetail(id){
      deleteFixDetail(this, id)
    },

    upFix(id){
      upFixApi(this, id)
    },

    cancelPublish(id){
      cancelPublishApi(this, id)
    },

    // 检查相关方法
    openAddPopup() {
      openAddPopup(this);
    },

    openFixPopup(){
      openFixPopup(this);
    },

    openAddDrawer(){
      this.showAddDrawer = true;
      this.mainRisk = '';
      this.riskIds = [];
      this.riskContent = '';
      this.changeRiskTime = '';
      this.changeId = '';
      this.isRiskChange = false;
    },

    handleCloseAddDrawer(){
      this.showAddDrawer = false;
      this.mainRisk = '';
      this.riskIds = [];
      this.riskContent = '';
      this.changeRiskTime = '';
      this.changeId = '';
      this.isRiskChange = false;
    },

    editCheckDetail(row) {
      editCheckDetail(this, row);
    },

    beforeUpload(file) {
      return beforeUpload(this, file);
    },

    customUpload({ file }) {
      customUpload(this, { file });
    },

    handleMouseEnter(date) {
      this.activeDate = date; // 设置当前悬停的日期
    },

    handleMouseLeave() {
      this.activeDate = ""; // 清除悬停日期
    },

    removeImage(index) {
      removeImage(this, index);
    },

    confirmInsert() {
      confirmInsert(this);
    },

    resetPopup() {
      resetPopup(this);
    },

    getChangeList(){
      getChangeList(this);
    },

    confirmChangeRisk(){
      confirmChangeRisk(this)
    },

    resetPopup2() {
      resetPopup2(this);
    },

    deleteDetail(id) {
      deleteDetail(this, id);
    },

    openImage(imageUrl) {
      openImage(this, imageUrl);
    },

    // 图表相关方法
    drewcav(title, data, levlist, type) {
      drewcav(this, title, data, levlist, type);
    },

    drewcav2(title, data) {
      drewcav2(this, title, data);
    },

    gettrendCav() {
      gettrendCav(this);
    },

    getriskCav(data) {
      getriskCav(this, data);
    },

    // 设备相关方法
    getEquipmentList() {
      getEquipmentList(this);
    },

    getcavdata(riskName) {
      getcavdata(this, riskName);
    },

    switchTab(tab) {
      this.activeTab = tab
      // ponytail: 切换到数据详情 tab 时触发 dataDetail 的数据加载
      if (tab === 'data' && this.$refs.dataDetailRef) {
        this.$nextTick(() => {
          const ref = this.$refs.dataDetailRef
          ref.getNowTime()
          ref.getEquipmentList()
          ref.getTopArr()
          ref.getMainTableData()
        })
      }
    },
    toDataManage() {
      // ponytail: 数据详情 tab 下的"监测管理"，跳转到监测点列表
      this.$router.push('/console/sites/list')
    },
    openDataExport() {
      // ponytail: 通过 ref 触发 dataDetail 的导出弹窗
      if (this.$refs.dataDetailRef) {
        this.$refs.dataDetailRef.showList = true
      }
    },

    changesave(data) {
      changesave(this, data);
    },

    changerisk(data) {
      changerisk(this, data);
    },

    getnow() {
      getnow(this);
    },

    getnewdata() {
      getnewdata(this);
    },

    getnowtime() {
      getnowtime(this);
    },

    changeitem(data, alertLevel) {
      changeitem(this, data, alertLevel);
    },

    // 保存数据相关方法
    getSaveData() {
      getSaveData(this);
    },

    getdbbl() {
      getdbbl(this);
    },

    uploadbl() {
      uploadbl(this);
    },

    showbl() {
      showbl(this);
    },

    // UI交互相关方法
    handleRemarkChange(row) {
      handleRemarkChange(this, row);
    },

    saveRemarkDevice(row) {
      saveRemarkDevice(this, row);
    },

    saveRemarkMisreport(row) {
      saveRemarkMisreport(this, row);
    },

    uploadDeal() {
      uploadDeal(this);
    },

    reset() {
      reset(this);
    },

    reset2() {
      reset2(this);
    },

    returnback() {
      returnback(this);
    },

    opendetail(data) {
      opendetail(this, data);
    },

    openhisLayer(data) {
      openhisLayer(this, data);
    },

    handlepageClick(data) {
      handlepageClick(this, data);
    },

    isToday(date) {
      return isToday(this, date);
    },

    changeDate(offset) {
      changeDate(this, offset);
    },

    todayDate() {
      todayDate(this);
    },

    lastHour() {
      lastHour(this);
    },

    // 时间线相关方法（已模块化的）
    handleCalendarChange() {
      return handleCalendarChange(this)
    },

    getCalendarDate(){
      getCalendarDate(this)
    },

    getRiskLevelClass(dateStr){
      return getRiskLevelClass(this, dateStr)
    },

    hasSpecialTag(dateStr){
      return hasSpecialTag(this,dateStr)
    },

    changetitle(index,item){
      changeTitle(this,index,item)
    },

    getRisktypeall(){
      getRiskTypeAll(this)
    },

    getriskTypeList(){
      getRiskTypeList(this)
    },

    getCheckList(){
      getCheckList(this)
    },

    pageChange(val) {
      this.nowpage = val
      this.getRiskList()
    },
    pageChange1(val) {
      this.nowpage1 = val
      this.getRisktypeall()
    },
    pageChangeCheck(val){
      this.checkPage = val;
      this.getCheckList();
    },

    getRiskList(){
      getRiskList(this)
    },
    getriskdeal(riskId){
      getRiskDeal(this, riskId)
    },

    // 获取隐患设备开机记录列表
    getEquipStartup(){
      getEquipStartup(this)
    },

    getDeviceType(){
      getDeviceType(this)
    },

    // 获取隐患设备详情
    getDeviceDetail(row) {
      getDeviceDetail(this, row)
    },

    getMisReportType() {
      getMisReportType(this)
    },

    getMisReport(row){
      getMisReport(this, row)
    },
    // 获取误报源隐患设备详情
    getMisReportDetail(row) {
      getMisReportDetail(this, row)
    },
    // 返回隐患设备列表
    returnToList() {
      returnToList(this)
    },
    // 返回误报源设备列表
    returnMisreportToList() {
      returnMisreportToList(this)
    },

    // 新增隐患分析
    initTimelineChart(riskData = [], is24Hours = false) {
      initTimelineChart(this, riskData, is24Hours);
    },
    getRiskColor(riskLevel) {
      return getRiskColor(riskLevel);
    },

    getriskone(){
      getRiskOne(this);
    },
    getrisktwo(){
      getRiskTwo(this);
    },
    getriskthree(){
      getRiskThree(this);
    },

    gettitleList(alertLevel,mess){
      getTitleList(this, alertLevel, mess);
    },

    // 获取隐患分析小时数据
    getRiskTimePeriodAnalyze(){
      getRiskTimePeriodAnalyze(this);
    },

    deleteDetailConfirm(item) {
      this.$confirm('确定要删除该现场排查记录吗？删除后数据将无法恢复。', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        customClass: 'delete-confirm-dialog'
      }).then(() => {
        deleteDetail(this, item.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    getFireData(){
      getFireData(this)
    },

    // 处置相关方法
    openDisposePopup() {
      openDisposePopup(this);
    },
    resetDisposePopup() {
      resetDisposePopup(this);
    },
    beforeDisposeUpload(file) {
      return beforeDisposeUpload(this, file);
    },
    customDisposeUpload({ file }) {
      customDisposeUpload(this, { file });
    },
    removeDisposePhoto(index) {
      removeDisposePhoto(this, index);
    },
    submitDispose() {
      submitDispose(this);
    },
    getDisposeList() {
      getDisposeList(this);
    },
    disposePageChange(page) {
      disposePageChange(this, page);
    },
    previewDisposePhoto(url) {
      previewDisposePhoto(this, url);
    },
    deleteDispose(row) {
      deleteDispose(this, row);
    },

    // 电动自行车充电识别配置
    openEbikeConfigPopup() {
      openEbikeConfigPopup(this);
    },
    submitEbikeConfig() {
      submitEbikeConfig(this);
    },
    resetEbikeConfig() {
      resetEbikeConfig(this);
    },
    toggleDemoMode(value) {
      toggleDemoMode(this, value);
    },
    // ponytail: keep-alive 缓存后数据加载逻辑抽成方法，供 mounted 和 activated 共用
    loadAllData() {
      this.getnowtime()
      this.getEquipmentList()
      this.getdbbl()
      this.getSaveData()
      this.getriskone()
      this.getrisktwo()
      this.getriskthree()
      this.handleCalendarChange(new Date())
      this.getCalendarDate()
      this.getRiskList()
      this.getriskTypeList();
      this.getCheckList();
      this.getDisposeList();
    },
  },

  mounted() {
    this.saveid = this.sanitizeSaveId(sessionStorage.getItem('saveid'));
    this.quickScreen = sessionStorage.getItem('quickScreen');
    // ponytail: 从数据详情页跳转时默认激活数据详情 tab
    const defaultTab = sessionStorage.getItem('defaultTab')
    if (defaultTab === 'data') {
      this.activeTab = 'data'
      sessionStorage.removeItem('defaultTab')
    }
    this.menusList = JSON.parse(localStorage.getItem("menusList"));
    this.isShowData = this.menusList.includes('MONITOR_DATA_DETAIL');
    this.hasPublishPermission = this.menusList.includes('MANUAL_ANALYSIS_PUBLISH');
    this.hasReportPermission = this.menusList.includes('MANUAL_ANALYSIS_REPORT');
    this.hasEbikeConfigPermission = this.menusList.includes('RECOGNITION_CONFIG');
    this.loadAllData()
  },
  // ponytail: keep-alive 缓存后 mounted 只跑一次，activated 每次切回时触发
  // 但只有 saveid 变化时才需要重新加载数据
  activated() {
    const newSaveid = this.sanitizeSaveId(sessionStorage.getItem('saveid'));
    if (newSaveid !== this.saveid) {
      this.saveid = newSaveid;
      this.loadAllData();
    }
  },
  watch: {
    newtm(newVal){
      let formattedDate;
      if(newVal instanceof Date || (typeof newVal === 'string' && newVal.includes('GMT'))){
        // 按本地日期取值：el-calendar 给的是本地 0 点 Date，用 toISOString 会退一天
        const d = new Date(newVal);
        const pad = n => n.toString().padStart(2, '0');
        formattedDate = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      } else {
        formattedDate = newVal;
      }
      if(formattedDate !== newVal){
        this.newtm = formattedDate;
        return;
      }
      this.getRiskTimePeriodAnalyze();
      this.handleCalendarChange();
      this.getCalendarDate();
      this.getFireData();
    }
  },

  components: {
    AppDrawer: () => import('@/pages/stationManagePage/components/AppDrawer.vue'),
    FixItem,
    SeChart,
    StationCard,
    TimeLine,
    powerData,
    CheckPart,
    DeviceType,
    dataDetail,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.stationDetailPage {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}

/* ponytail: 能耗统计卡片 — 移除 station-card 默认内边距让内容撑满 */
.energy-card {
  :deep(.detail-content) {
    padding: 0;
    align-items: stretch;
  }
}

/* ── 顶部信息栏 ── */
.detail-top {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px 24px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .station-top-row {
    display: flex;
    align-items: flex-start;
    gap: 32px;

    .station-id {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 0;

      .station-title {
        font-size: 18px;
        font-weight: 600;
        color: #252B3C;
      }

      .station-dept {
        font-size: 14px;
        color: #7D879F;
      }
    }

    .station-meta {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;

      .meta-item {
        display: flex;
        align-items: center;
        gap: 6px;

        .meta-label {
          font-size: 13px;
          color: #909399;
        }

        .meta-value {
          font-size: 14px;
          color: #252B3C;
          font-weight: 500;
        }
      }

      .meta-divider {
        width: 1px;
        height: 16px;
        background: #E4E7ED;
      }
    }
  }

  .detail-tabs-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    border-bottom: 1px solid #E8E8E8;

    .tabs-group {
      display: flex;
      align-items: center;
      gap: 0;

      .tab-btn {
        padding: 10px 24px;
        font-size: 14px;
        color: #909399;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
        transition: all 0.2s;
        user-select: none;

        &:hover {
          color: #2A62FF;
        }

        &.active {
          color: #2A62FF;
          font-weight: 600;
          border-bottom-color: #2A62FF;
        }
      }
    }

    .action-group {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-bottom: 8px;
    }
  }
}

/* ── 内容区 ── */
.detail-content {
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: 20px 0;

  .select-check {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* ponytail: el-button 默认样式使用 shadow DOM 方式注入，
     此处用更高特异性选择器替代 !important，避免污染全局 */
  .plain-time-btn.el-button.el-button--default {
    border-color: transparent;
    background: transparent;
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
      border-color: transparent;
      background: transparent;
      box-shadow: none;
    }
  }

  .linePart {
    flex: 1;
    display: flex;
  }

  .data-table{
    height: 500px;
    max-height: 500px;
    overflow-y: auto;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .nodata-table {
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 139, 7, 0.5);
    font-size: 30px !important;
    box-sizing: border-box;
  }

  .timePart{
    width: 20%;
    min-width: 25rem;

    .calendar ::v-deep .el-calendar-table .el-calendar-day{
      height: 50px;
    }
  }

  .riskPart{
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .risk-choose{
    width: 100%;
    height: 45px;
    min-width: 0;
    min-height: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
  }

  .time-line {
    flex: 1;
    height: 100%;
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .time-line-part{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  .point-line-part{
    height: 300px;
    width: 100%;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .date-part{
    height: 100%;
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 2px;
    position: relative;

    .tooltip {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: 20;
    }

    .tooltip::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 4px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.8);
    }

    .date-info{
      flex: 1;
      text-align: center;
    }

    .right-info{
      display: flex;
      align-items: end;
      justify-content: center;
    }

    .risk-part{
      height: 6px;
      width: 20px;
      position: relative;
    }

    .isMis {
      position: absolute;
      right: 0;
      top: 0;
      height: 6px;
      width: 10px;
      padding: 2px;
      border-radius:0 4px 4px 0;
      background: #6c6c6c;
    }

    .risk1 { background: #69FC24; border-radius: 4px; padding: 2px; }
    .risk2 { background: #378def; border-radius: 4px; padding: 2px; }
    .risk3 { background: #378def; border-radius: 4px; padding: 2px; }
    .risk4 { background: #ff7a45; border-radius: 4px; padding: 2px; }
    .risk5 { background-color: rgba(231,43,9,0.6); border-radius: 4px; padding: 2px; }
  }

  .hidden-part {
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 20px;

    .device { flex: 1; min-width: 0; }
    .false-report { flex: 1; min-width: 0; }

    .device-container {
      position: relative;
      width: 100%;
      min-width: 0;
      display: flex;
      flex-direction: column;
    }

    .device-header {
      position: absolute;
      top: 0;
      right: 20px;
      z-index: 1;

      .return-btn {
        padding: 5px 15px;
        font-size: 14px;
        .el-icon-arrow-left { margin-right: 5px; }
      }
    }
  }

  .history-risk {
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .history { flex: 1; min-width: 0; }
  .total { flex: 1; min-width: 0; }

  .hidden-table {
    width: 100%;
    height: 500px;
    max-height: 500px;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .time-select {
    width: 100%;
    height: 80px;
    min-width: 0;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .misreport{
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F6F6F6;
    border-radius: 5px;
    font-size: 16px;
    font-family: OPPOSans-M, sans-serif;
  }

  .btn {
    width: 58px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    background: var(--bg);
    color: var(--color);
  }

  .search { --bg: #2A62FF; --color: #fff; }
  .restart { --bg: #fff; --color: #2A62FF; }

  .list-table {
    flex: 1;
    width: 100%;
    min-width: 0;
    min-height: 0;
    box-sizing: border-box;
    overflow-y: auto;
  }

  .hidden-page {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: right;
    align-items: center;
    padding-right: 10px;
  }

  .checkList {
    width: 100%;
    min-width: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .power-data{
    margin-top: 40px;
    color: #252B3C;
    font-size: 14px;
  }

  .data-card{
    margin-top: 24px;
    position: relative;
    .btn-item{
      position: absolute;
      right: 40px;
      top: 20px;
      display: inline-block;
      width: 120px;
      height: 40px;
      background: #2A62FF;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin-left: 48px;
      cursor: pointer;
    }
  }

  .save-item{
    position: relative;
    display: inline-block;
    height: 50px;
    padding-left: 16px;
    margin-right: 150px;
    .blue-blank{
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 50px;
      background: #2A62FF;
    }
    .green-font{ font-size: 14px; color: #008B61; }
    .red-font{ font-size: 14px; color: #D61E1E; }
    .org-font{ font-size: 14px; color: #D17300; }
    .yel-font{ font-size: 14px; color: #D1B500; }
    .blue-font{ font-size: 14px; color: #2A62FF; }
    .item-tips{ margin-top: 14px; color: #7D879F; }
  }

  .risk-history-title{
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;

    .img-button {
      width: 20px;
      height: 20px;
      position: absolute;
      left: 5px;
      top: 0;
      cursor: pointer;
    }
  }
  .close-X{
    position: absolute;
    top: 23px;
    right: 23px;
    cursor: pointer;
    z-index: 1000;
  }
  .search-blank{ padding:11px 36px 0 36px; }
}

/* ── Drawer 共享样式 ── */
.fix-change{
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 24px;
  background-color: #F5F7FA;
}

.fix-list{
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .fix-header{
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 8px;
  }

  .fix-content{
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;
  }
}

.fix-part{
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.fix-part1{
  flex: 0 0 80px;
  text-align: right;
  padding-right: 16px;
  color: #252B3C;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}

.fix-part2{
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 100%;

  .main-risk-tag {
    padding: 4px 12px;
    background-color: #F0F7FF;
    border-radius: 4px;
    color: #2A62FF;
    font-size: 14px;
    font-weight: 500;
  }
}

.fix-bottom{
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.ebike-config-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

/* ── Drawer 内部区块 ── */
.drawer-section {
  margin-bottom: 24px;

  .drawer-section-title {
    font-size: 15px;
    font-weight: 600;
    color: #252B3C;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #F0F0F0;
  }
}

.history-steps {
  max-height: 320px;
  overflow-y: auto;
  /* ponytail: 使用细滚动条而非完全隐藏，保留可用性 */
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
  .fontStyle {
    font-size: 14px;
    color: #252b3c;
  }
}
</style>

<style lang="less">
#app .el-pagination .el-pager li.active {
  color: #fff;
}

#app .stationDetailPage .risk-history .el-table td, .el-table th.is-leaf {
  border-bottom: 1px dashed rgba(0,0,0,0.2);
}

#app .stationDetailPage .el-table th, .el-table tr {
  height: 50px;
}

#app .stationDetailPage .el-table thead th {
  background-color: #F0F7FF;
  color: #7D879F;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}

.el-table__body-wrapper::-webkit-scrollbar-track { display: none; }
.el-table__body-wrapper::-webkit-scrollbar-thumb { display: none; }

/* ── 统一 Drawer 头部样式 ── */
.app-drawer {
  .el-drawer__header {
    padding: 20px 24px;
    margin-bottom: 0;
    border-bottom: 1px solid #E4E7ED;
    background-color: #FFFFFF;
    span {
      font-size: 17px;
      font-weight: 600;
      color: #252B3C;
    }
  }

  .el-drawer__body {
    padding: 0;
    background-color: #F5F7FA;
    overflow-y: auto;
  }

  .el-drawer__close-btn {
    &:focus { outline: none; }
  }
}

.fix-add-drawer {
  z-index: 3000 !important;
}

/* ── 删除确认弹框样式 ── */
.delete-confirm-dialog {
  .el-message-box__header {
    padding: 20px 20px 15px;
    .el-message-box__title { font-size: 18px; font-weight: 600; color: #252B3C; }
  }
  .el-message-box__content {
    padding: 15px 20px;
    .el-message-box__message { font-size: 14px; color: #5A5E66; line-height: 1.6; }
    .el-icon-warning { color: #E6A23C; font-size: 20px; }
  }
  .el-message-box__btns {
    padding: 15px 20px 20px;
    .el-button--danger {
      background-color: #F56C6C; border-color: #F56C6C;
      &:hover { background-color: #F78989; border-color: #F78989; }
    }
  }
}

/* ── Ebike config drawer divider ── */
.ebike-config-drawer {
  .el-divider__text {
    font-size: 13px;
    color: #2A62FF;
    font-weight: 500;
  }
}
</style>
